import type { SavedFalconOrder } from '@/domain/WorkspaceForex/savedProducts/order/SavedFalconOrder.ts';
import type { FalconOrder } from '@/store/orders/algoOrders/state.ts';

export const mapToFalcon = (savedTile: SavedFalconOrder): FalconOrder => {
  return {
    ...savedTile,
    properties: {
      ...savedTile.properties,
    },
  };
};
